import {AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {appFormValidateUrl} from '@core/form/validator/form-url.validator';
import {touchedRequiredValidator} from '@core/form/validator/form-touched-required.validator';
import {CoreAppFormGroup} from '@core/form/form.group';
import {HttpMethodsEnum} from '@core/http/methods.enum';

enum AddSourceFormFields {
    File = 'file',
    Link = 'link',
    Title = 'title',
    VisibleFor = 'visibleFor',
    ChapterUuid = 'chapterUuid',
    DocumentDpsId = 'documentDpsId',
}

const fileOrLinkRequiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const fileFieldValue: string = (control.get(AddSourceFormFields.File) as AbstractControl).value ?? '';
    const linkFieldValue: string = (control.get(AddSourceFormFields.Link) as AbstractControl).value ?? '';

    return control.touched && 0 === fileFieldValue.length && 0 === linkFieldValue.length ? {fileOrLinkRequired: true} : null;
}

export class AddSourceDialogForm extends CoreAppFormGroup {
    constructor() {
        super({
            [AddSourceFormFields.File]: new FormControl(''),
            [AddSourceFormFields.Link]: new FormControl('', appFormValidateUrl),
            [AddSourceFormFields.Title]: new FormControl('', [Validators.required, Validators.minLength(2)]),
            [AddSourceFormFields.VisibleFor]: new FormControl('', touchedRequiredValidator),
            [AddSourceFormFields.ChapterUuid]: new FormControl('', touchedRequiredValidator),
            [AddSourceFormFields.DocumentDpsId]: new FormControl(''),
        }, {
            validators: fileOrLinkRequiredValidator,
            updateOn: 'submit',
        });
    }

    get title(): FormControl {
        return this.get(AddSourceFormFields.Title) as FormControl;
    }

    get file(): FormControl {
        return this.get(AddSourceFormFields.File) as FormControl;
    }

    get link(): FormControl {
        return this.get(AddSourceFormFields.Link) as FormControl;
    }

    get visibleFor(): FormControl {
        return this.get(AddSourceFormFields.VisibleFor) as FormControl;
    }

    get chapterUuid(): FormControl {
        return this.get(AddSourceFormFields.ChapterUuid) as FormControl;
    }

    get documentDpsId(): FormControl {
        return this.get(AddSourceFormFields.DocumentDpsId) as FormControl;
    }

    setChapterUuid(value: string): AddSourceDialogForm {
        this.patchValue({[AddSourceFormFields.ChapterUuid]: value});
        this.setDocumentDpsId(null); // Clear document selection when selecting chapter

        return this;
    }

    setFile(file: File | null): AddSourceDialogForm {
        this.patchValue({[AddSourceFormFields.File]: null !== file ? [file] : ''});
        this.setLink(null);

        return this;
    }

    setLink(value: string | null): AddSourceDialogForm {
        this.patchValue({[AddSourceFormFields.Link]: null !== value ? value : ''});

        return this;
    }

    setDocumentDpsId(value: string | null): AddSourceDialogForm {
        this.patchValue({[AddSourceFormFields.DocumentDpsId]: null !== value ? value : ''});

        return this;
    }

    getMode(): HttpMethodsEnum {
        throw Error('Not implemented');
    }

    getAll(): any {
        throw Error('Not implemented');
    }
}
